module.exports = __webpack_public_path__ + "static/img/diease.4399a94b.png";